import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { sendOfferApi } from "../../features/Lead/leadsAPI";
import * as Endpoints from "../../entities/Endpoints";
import axiosPublicInstance from "../../services/axiosPublicInstance";

// Async thunk for sending the offer
export const sendOfferThunk = createAsyncThunk(
  "leads/sendOffer",
  async ({ coachId, offerPayload }, { rejectWithValue }) => {
    try {
      return await sendOfferApi(coachId, offerPayload);
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to send offer");
    }
  }
);

// Async thunk for Lead Offer Details
export const getOfferDetails = createAsyncThunk(
  `${Endpoints.GET_LEAD_OFFER_DETAILS}`,
  async ({ leadOfferDetailsId }, { rejectWithValue }) => {
    try {
      const response = await axiosPublicInstance.get(
        `${Endpoints.GET_LEAD_OFFER_DETAILS}/${leadOfferDetailsId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch lead offer details"
      );
    }
  }
);

const sendOfferSlice = createSlice({
  name: "sendOffer",
  initialState: {
    loading: false,
    error: null,
    offerResponse: null,

    // Added for getOfferDetails
    offerData: null,
    errorLeadOfferDetails: null,
    success: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Send Offer
      .addCase(sendOfferThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendOfferThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.offerResponse = action.payload;
      })
      .addCase(sendOfferThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Lead Offer Details
      .addCase(getOfferDetails.pending, (state) => {
        state.loading = true;
        state.errorLeadOfferDetails = null;
        state.success = null;
      })
      .addCase(getOfferDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.offerData = action.payload;
        // state.success = "Lead offer details fetched successfully";
        state.errorLeadOfferDetails = null;
      })
      .addCase(getOfferDetails.rejected, (state, action) => {
        state.loading = false;
        state.errorLeadOfferDetails = action.payload;
        state.success = null;
      });
  },
});

export default sendOfferSlice.reducer;
